// eslint-disable-next-line
export default {
  REQUESTED_APPOINTMENTS_NOT_FOUND: "No Appointment Requests Found",
  SCHEDULED_APPOINTMENTS_NOT_FOUND: "No Scheduled Appointment Found",
  NOTIFICATIONS_NOT_FOUND: "No Notifications Found",
  AVAILABILITY_SCHEDULE_SUCCESS: "Availability Schedule Updated",
  PERSONAL_DETAILS_SUCCESS: "Personal Details Updated Successfully",
  PERSONAL_DETAILS_ADDED_SUCCESS: "Personal Details Added Successfully",
  CONTACT_ADDED_DETAILS_SUCCESS: "Contact Details Added Successfully",
  CONTACT_DETAILS_SUCCESS: "Contact Details Updated Successfully",
  MEDICAL_RECORD_ADDED_SUCCESS: "Medical Records Added Successfully",
  MEDICAL_RECORD_UPDATE_SUCCESS: "Medical Records Updated Successfully",
  PRACTICE_DETAILS_SUCCESS: "Practice Details Updated Successfully",
  DOCUMENT_DETAILS_SUCCESS: "Document Details Updated Successfully",
  PERSONALISED_DETAILS_SUCCESS: "Personalise Experience Updated",
  PCP_REQUEST_DENIED: "Request Denied",
  MAX_FILE_SIZE: "File size should not be greater than 5MB",
  INVALID_FILE: "Please select valid profile image",
  INVALID_IMAGE: "Please select image files only",
  INVALID_DOCUMENT: "Please select valid document",
  PATIENTS_NOT_FOUND: "No Patients Found",
  APPOINTMENT_EXPIRED: "Appointment Expired",
  APPOINTMENT_START_CALL:
    "Appoinment Call can be started 10 minutes prior to Start time",
  APPOINTMENT_TIME_EXPIRED: "This appointment has been attended or expired",
  NOTE_TEMPLATE_CREATED_SUCCESS: "Note Template Successfully Created",
  NOTE_TEMPLATE_EDITED_SUCCESS: "Note Template Successfully Updated",
  NOTE_EDITED_SUCCESS: "Note Successfully Updated",
  NOTE_CREATED_SUCCESS: "Note Successfully Created",
  NOTE_DELETED_SUCCESS: "Note Successfully Deleted",
  NOTE_REQUIRED_FILEDS: "Please fill all the required fields in notes",
  VISIT_NOW_REQUEST_SENT: "Visit Now Request Successfully Sent",
  VISIT_NOW_REQUEST_UPDATED: "Visit Now Request Update",
  VISIT_NOW_REQUEST_DENIED: "Visit Now Request Denied",
  INVITE_SENT_SUCCESS: "Invite Sent Successfully",
  INVITE_CANCEL_SUCCESS: "Invite Canceled Successfully",
  INVITE_ACCEPTED_SUCCESS: "Invite Accepted Successfully",
  INVITE_DENIED_SUCCESS: "Invite Denied Successfully",
  INVITE_UPDATED_SUCCESS: "Invite Updated Successfully",
  REQUEST_DENIED_SUCCESS: "Request denied successfully",
  DOSESPOT_PROFILE_ERROR: "e-Prescription profile is required",
  SOMTHING_WENT_WRONG: "Something went wrong please try again",
};
